export default __webpack_public_path__ + "static/media/skills@3x.1c3aed4b.png";